<template>
  <div class="maternal-video-page">
    <header class="page-header">
      <div class="container">
        <div class="breadcrumb-section">
          <h2 class="current-category-title">妇幼视频</h2>
        </div>
      </div>
    </header>

    <div class="container">
      <div class="video-grid">
        <div v-for="video in videos" :key="video.id" class="video-card" @click="goToDetail(video)">
          <div class="video-cover">
            <img v-if="video.image" :src="video.image" :alt="video.title" />
            <div class="play-icon"></div>
          </div>
          <div class="video-info">
            <h3 class="video-title">{{ video.title }}</h3>
            <p class="video-date">{{ video.date }}</p>
          </div>
        </div>
      </div>

      <div class="pagination-wrapper">
        <span class="total-text">共 {{ totalItems }} 条</span>
        <button class="page-btn" :disabled="currentPage === 1" @click="prevPage">&lt;</button>
        
        <template v-if="totalPages <= 7">
          <button v-for="page in visiblePages" :key="page" class="page-btn" :class="{ active: currentPage === page }" @click="goToPage(page)">
            {{ page }}
          </button>
        </template>
        
        <template v-else>
          <template v-if="currentPage <= 4">
            <button v-for="page in visiblePages" :key="page" class="page-btn" :class="{ active: currentPage === page }" @click="goToPage(page)">
              {{ page }}
            </button>
            <span class="ellipsis">...</span>
            <button class="page-btn" @click="goToPage(totalPages)">{{ totalPages }}</button>
          </template>
          
          <template v-else-if="currentPage >= totalPages - 3">
            <button class="page-btn" @click="goToPage(1)">1</button>
            <span class="ellipsis">...</span>
            <button v-for="page in visiblePages" :key="page" class="page-btn" :class="{ active: currentPage === page }" @click="goToPage(page)">
              {{ page }}
            </button>
          </template>
          
          <template v-else>
            <button class="page-btn" @click="goToPage(1)">1</button>
            <span class="ellipsis">...</span>
            <button v-for="page in visiblePages.slice(2, 5)" :key="page" class="page-btn" :class="{ active: currentPage === page }" @click="goToPage(page)">
              {{ page }}
            </button>
            <span class="ellipsis">...</span>
            <button class="page-btn" @click="goToPage(totalPages)">{{ totalPages }}</button>
          </template>
        </template>
        
        <button class="page-btn" :disabled="currentPage >= totalPages" @click="nextPage">&gt;</button>
        <select class="page-size-select" v-model="pageSize" @change="onPageSizeChange">
          <option value="12">12 条/页</option>
          <option value="20">20 条/页</option>
          <option value="30">30 条/页</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MaternalVideo',
  data() {
    return {
      videos: [],
      currentPage: 1,
      pageSize: 12,
      totalPages: 1,
      totalItems: 0,
      videoCategoryId: 6
    }
  },
  computed: {
    visiblePages() {
      const pages = []
      const total = this.totalPages
      const current = this.currentPage
      
      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i)
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i)
          }
        } else if (current >= total - 3) {
          for (let i = total - 4; i <= total; i++) {
            pages.push(i)
          }
        } else {
          pages.push(1)
          pages.push(current - 1, current, current + 1)
          pages.push(total)
        }
      }
      return pages
    }
  },
  mounted() {
    this.fetchCategories().then(() => {
      this.fetchVideos()
    })
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await axios.get('/api/categories')
        if (response.data && response.data.flat) {
          const videoCat = response.data.flat.find(cat => cat.name === '妇幼视频')
          if (videoCat) {
            this.videoCategoryId = videoCat.id
          }
        }
      } catch (error) {
        console.error('获取分类失败:', error)
      }
    },
    async fetchVideos() {
      try {
        const response = await axios.get('/api/posts', {
          params: {
            page: this.currentPage,
            size: this.pageSize,
            category_id: this.videoCategoryId
          }
        })
        this.videos = response.data.data || []
        const total = response.data.total || this.videos.length
        this.totalItems = total
        this.totalPages = Math.ceil(total / this.pageSize)
      } catch (error) {
        console.error('获取视频列表失败:', error)
        this.videos = []
      }
    },
    goToDetail(article) {
      if (article.external_link) {
        window.open(article.external_link, '_blank')
      } else {
        this.$router.push(`/article/${article.id}`)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchVideos()
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.fetchVideos()
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page
        this.fetchVideos()
      }
    },
    onPageSizeChange() {
      this.currentPage = 1
      this.fetchVideos()
    }
  }
}
</script>

<style lang="less" scoped>
.maternal-video-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 198px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .breadcrumb-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .current-category-title {
    font-size: 36px;
    font-weight: bold;
    color: #4ecdc4;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 25px;
}

.video-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  .video-cover {
    position: relative;
    width: 100%;
    height: 180px;
    overflow: hidden;
    background: #eee;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .play-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
      background: rgba(78, 205, 196, 0.9);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &::after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-left: 24px solid white;
        border-top: 14px solid transparent;
        border-bottom: 14px solid transparent;
        margin-left: 4px;
      }
    }
  }

  .video-info {
    padding: 15px;

    .video-title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 0 0 8px 0;
      line-height: 1.4;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .video-date {
      font-size: 13px;
      color: #999;
      margin: 0;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  margin-top: 30px;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .total-text {
    font-size: 14px;
    color: #333;
    margin-right: 10px;
    line-height: 1.4;
  }

  .page-btn {
    width: 38px;
    height: 32px;
    background: white;
    color: #333;
    border: 1px solid #eee;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &:hover {
      border-color: #4ecdc4;
      color: #4ecdc4;
    }

    &.active {
      border-color: #4ecdc4;
      color: #4ecdc4;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .ellipsis {
    font-size: 14px;
    color: #999;
    width: 24px;
    text-align: center;
  }

  .page-size-select {
    width: 100px;
    height: 32px;
    background: white;
    color: #333;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 30px 0 10px;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    transition: border-color 0.3s;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%234ecdc4' d='M6 8L0 2L1.4 0.6L6 5.2L10.6 0.6L12 2L6 8Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    
    &:focus {
      border-color: #4ecdc4;
    }
  }

  .page-size-select option {
    background: white;
    color: #333;
    
    &:checked {
      background: #4ecdc4;
      color: white;
    }
  }
}
</style>
